(() => {
    const locationData = Intl.DateTimeFormat().resolvedOptions();
    const locale = locationData.locale;
    const origin = window.origin;
    const dataStorage = getItemLocalStorage('_loc_market');
    const hostname = window.location.hostname;
    const currentPath = window.location.pathname.replace(/\/$/, '');
    const principalLocale = 'en-US';
    const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
    const isAdminHost = /(^|\.)admin\.shopify\.com$/i.test(window.location.hostname);
    const isAdminPath = /\/admin\b/.test(window.location.pathname);
    const isAdminReferrer = /myshopify\.com\/admin/.test(document.referrer || '');

    if (dataStorage && dataStorage.isactuallocation === locale) {
        return;
    }

    if((locale != principalLocale) && !isThemeEditor && !isAdminHost && !isAdminPath && !isAdminReferrer) {
        setItemLocalStorage('_loc_market', { isactuallocation: locale }, 3).then(() => {
            redirect();
        });
    }

    function redirect() {
        switch (locale) {
            case 'es-MX':
                window.location.href = `${origin}/es-mx`;
                break;

            case 'en-CA':
                window.location.href = `${origin}/en-ca`;
                break;

            case 'en-US':
                window.location.href = `${origin}/en-us`;
                break;

            default:
                window.location.href = `${origin}/en-us`;
                break;
        }
    }

    function setItemLocalStorageMin(key, value, minutes) {
        return new Promise((resolve, reject) => {
            const now = new Date();
            const item = {
                value: value,
                expiry: now.getTime() + (minutes * 60 * 1000),
            };
            localStorage.setItem(key, JSON.stringify(item));
            resolve();
        });
    }

    function getItemLocalStorageMin(key) {
        const itemString = localStorage.getItem(key);
        if (!itemString) {
            return null;
        }

        const item = JSON.parse(itemString);
        const now = new Date();

        if (now.getTime() > item.expiry) {
            removeItemLocalStorage(key);
            return null;
        }
        return item.value;
    }

    function removeItemLocalStorage(key) {
        localStorage.removeItem(key);
    }

    function setItemLocalStorage(key, value, days) {
        return new Promise((resolve, rejcet) => {
            const now = new Date();
            const expiryTime = now.getTime() + (days * 24 * 60 * 60 * 1000);
            const item = {
                value: value,
                expiry: expiryTime
            };
            localStorage.setItem(key, JSON.stringify(item));
            resolve();
        });
    }

    function getItemLocalStorage(key) {
        const itemString = localStorage.getItem(key);
        const item = JSON.parse(itemString);
        const now = new Date();

        if(itemString) {
            if (now.getTime() > item.expiry) {
                removeItemLocalStorage(key);
                return null;
            }
            return item.value;
        }
    }
})();